//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import GetReviews from '~/mixins/yotpo/get-reviews'

export default {
  mixins: [GetReviews],
  data () {
    return {
      numReviews: 0
    }
  },
  async fetch () {
    const bottomLine = await this.getYotpoTotalReviewsAndScore()
    this.numReviews = bottomLine.total_reviews
  },
  fetchOnServer: false
}
